import { GlobalStyle } from "./styles/global-style";
import { ThemeProvider } from "styled-components";
import { theme } from "./styles/theme";
import Router from "./routes/Router";

function App() {
  return (
    <>
      <ThemeProvider theme={theme}>
        <GlobalStyle />
        <Router />
      </ThemeProvider>
    </>
  );
}

export default App;
